import { render, staticRenderFns } from "./DetailsChat.vue?vue&type=template&id=64e42aea"
import script from "./DetailsChat.vue?vue&type=script&lang=ts"
export * from "./DetailsChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports